import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import logowhite from '../../assets/images/moidtechwhite.png';

const privacySections = [
  {
    title: '1. Información que podemos recopilar',
    paragraphs: [
      'Si nos contactas por correo electrónico u otro canal, podemos recibir los datos que decidas compartir, como tu nombre, correo electrónico, teléfono, asunto y el contenido de tu mensaje. El formulario de contacto de este sitio, en su estado actual, no transmite los datos ingresados a MOID Tech; la interacción queda en el navegador.',
      'Si nos escribes por WhatsApp, Instagram o Messenger, nuestro chatbot puede procesar el contenido de tus mensajes y los datos que la plataforma facilite para responder, como tu número de WhatsApp o identificador y nombre de perfil de Instagram o Facebook. Te pedimos no enviar información sensible que no sea necesaria para tu consulta.',
      'Utilizamos Google Analytics para conocer cómo se utiliza el sitio y mejorar su funcionamiento. Esta herramienta puede recopilar datos de navegación e interacción, información del dispositivo y navegador, identificadores en cookies y datos técnicos como la dirección IP, de acuerdo con la configuración del servicio.',
      'El proveedor de alojamiento también podría procesar datos técnicos básicos necesarios para entregar y proteger la página, como la dirección IP, el navegador y la fecha de acceso.',
    ],
  },
  {
    title: '2. Cómo usamos la información',
    paragraphs: [
      'Usamos los datos que nos envías para responder consultas, conversar sobre posibles proyectos, prestar atención al cliente y mantener la seguridad del sitio. En WhatsApp, Instagram y Messenger, el chatbot procesa automáticamente tus mensajes para responder preguntas sobre nuestros productos. No usamos el contenido de esos mensajes para fines publicitarios propios. Solo utilizaremos la información para otros fines cuando exista una base legítima para hacerlo o nos hayas dado tu consentimiento cuando corresponda.',
    ],
  },
  {
    title: '3. Compartición de datos',
    paragraphs: [
      'No vendemos tus datos personales. La mensajería se integra directamente con los servicios de Meta (WhatsApp, Instagram y Messenger), sin una plataforma intermediaria de chatbot. Meta transmite y procesa los mensajes y datos de cuenta necesarios para que funcione la conversación, de acuerdo con sus propias condiciones y políticas. Google Analytics recibe datos de uso para prestar el servicio de medición descrito en esta política. Los proveedores de alojamiento o seguridad también pueden procesar datos técnicos necesarios para operar el sitio, y podremos divulgar información si una obligación legal lo requiere.',
    ],
  },
  {
    title: '4. Conservación y seguridad',
    paragraphs: [
      'El chatbot no conserva una copia propia de tus mensajes ni de tus datos de perfil una vez procesada y enviada la respuesta. Meta puede conservar la conversación y los datos asociados en sus plataformas conforme a sus propias políticas, condiciones y controles de cuenta. Para solicitar la eliminación de una conversación de WhatsApp, Instagram o Messenger, utiliza también las opciones disponibles en la plataforma correspondiente. Aplicamos medidas razonables para proteger la información que tratamos; aun así, ningún sistema de transmisión o almacenamiento puede garantizar seguridad absoluta.',
    ],
  },
  {
    title: '5. Cookies y enlaces externos',
    paragraphs: [
      'Google Analytics utiliza cookies o tecnologías similares para distinguir visitas y medir la actividad del sitio. Puedes limitar o borrar cookies desde la configuración de tu navegador. El tratamiento de datos por Meta se rige también por su política de privacidad. Los demás enlaces a sitios de terceros están sujetos a sus propias políticas y prácticas; te recomendamos consultarlas antes de compartir información con ellos.',
    ],
  },
  {
    title: '6. Tus opciones y derechos',
    paragraphs: [
      'Según la normativa aplicable en tu lugar de residencia, puedes tener derecho a solicitar acceso, corrección o eliminación de tus datos, o a oponerte a determinados usos. Para consultas sobre el tratamiento por MOID Tech, escríbenos a hola@moid.tech; como el chatbot no conserva una copia propia de los chats una vez respondidos, las solicitudes sobre conversaciones retenidas en WhatsApp, Instagram o Messenger deben dirigirse también a Meta mediante las opciones de cada servicio. Es posible que necesitemos verificar tu identidad antes de responder.',
    ],
  },
  {
    title: '7. Actualizaciones y contacto',
    paragraphs: [
      'Podemos actualizar esta política para reflejar cambios en el sitio o en nuestras prácticas. Publicaremos la versión vigente en esta página. Si tienes preguntas sobre privacidad, contáctanos en hola@moid.tech.',
    ],
  },
];

const termsSections = [
  {
    title: '1. Aceptación y alcance',
    paragraphs: [
      'Al acceder o utilizar moid.tech aceptas estos términos. Si no estás de acuerdo, deja de utilizar el sitio. Estos términos regulan el uso de la página informativa de MOID Tech; cualquier servicio contratado se regirá además por la propuesta, orden de trabajo o contrato acordado con el cliente.',
    ],
  },
  {
    title: '2. Uso del sitio',
    paragraphs: [
      'Te comprometes a utilizar el sitio de forma lícita y a no interferir con su funcionamiento, intentar acceder sin autorización a sus sistemas, distribuir código malicioso ni utilizar sus contenidos para vulnerar derechos de otras personas.',
      'La información del sitio tiene carácter general y puede cambiar sin previo aviso. Una consulta o solicitud de contacto no constituye por sí sola una oferta vinculante ni crea una relación profesional.',
    ],
  },
  {
    title: '3. Propiedad intelectual',
    paragraphs: [
      'Salvo que se indique lo contrario, los textos, diseños, marcas, gráficos y demás contenidos del sitio pertenecen a MOID Tech o se utilizan con autorización. No está permitido copiarlos, modificarlos, distribuirlos o explotarlos comercialmente sin autorización previa, excepto cuando la ley lo permita.',
    ],
  },
  {
    title: '4. Servicios y proyectos',
    paragraphs: [
      'El alcance, precio, plazos, entregables, soporte y derechos sobre el trabajo de cualquier proyecto se definirán en el acuerdo específico con el cliente. La información publicada en este sitio no sustituye ese acuerdo.',
    ],
  },
  {
    title: '5. Enlaces y disponibilidad',
    paragraphs: [
      'El sitio puede incluir enlaces a servicios de terceros, cuyo contenido y funcionamiento no controlamos. Procuramos mantener la página disponible y actualizada, pero no garantizamos que esté libre de interrupciones, errores o componentes dañinos en todo momento.',
    ],
  },
  {
    title: '6. Responsabilidad',
    paragraphs: [
      'En la medida permitida por la normativa aplicable, MOID Tech no será responsable por daños derivados de la imposibilidad de utilizar el sitio, de decisiones tomadas únicamente con base en su contenido o de servicios y contenidos de terceros. Nada de estos términos limita responsabilidades que no puedan excluirse legalmente.',
    ],
  },
  {
    title: '7. Cambios y contacto',
    paragraphs: [
      'Podemos modificar estos términos cuando sea necesario. La versión publicada en esta página será la vigente desde su publicación. Si tienes preguntas, escríbenos a hola@moid.tech.',
    ],
  },
];

function LegalPage({ type }) {
  const isPrivacy = type === 'privacy';
  const sections = isPrivacy ? privacySections : termsSections;
  const title = isPrivacy ? 'Política de privacidad' : 'Términos y condiciones';
  const eyebrow = isPrivacy ? 'PRIVACIDAD' : 'CONDICIONES DE USO';

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [type]);

  return (
    <div className="legal-page">
      <header className="legal-header">
        <Link className="legal-brand" to="/" aria-label="MOID Tech, inicio">
          <img src={logowhite} alt="MOID Tech" width="90" height="24" />
        </Link>
        <nav className="legal-nav" aria-label="Documentos legales">
          <Link className={isPrivacy ? 'is-active' : ''} to="/privacy-policy">Privacidad</Link>
          <Link className={!isPrivacy ? 'is-active' : ''} to="/terms-and-conditions">Términos</Link>
        </nav>
        <Link className="legal-contact" to="/contact">Contacto <span aria-hidden="true">↗</span></Link>
      </header>

      <main className="legal-main">
        <div className="legal-heading">
          <span className="legal-eyebrow">{eyebrow} <i aria-hidden="true" /></span>
          <h1>{title}</h1>
          <p>La claridad y la confianza también forman parte de un buen producto digital.</p>
          <span className="legal-updated">Última actualización: 10 de octubre de 2026</span>
        </div>

        <div className="legal-layout">
          <aside className="legal-aside">
            <span>EN ESTA PÁGINA</span>
            <nav aria-label="Secciones del documento">
              {sections.map((section, index) => (
                <a href={`#legal-section-${index + 1}`} key={section.title}>
                  {section.title.replace(/^\d+\.\s*/, '')}
                </a>
              ))}
            </nav>
            <p>¿Tienes alguna pregunta?</p>
            <a className="legal-aside-contact" href="mailto:hola@moid.tech">hola@moid.tech ↗</a>
          </aside>

          <article className="legal-content">
            <p className="legal-intro">
              {isPrivacy
                ? 'En esta política explicamos qué información puede recibir MOID Tech cuando utilizas este sitio y cómo la tratamos.'
                : 'Estas condiciones describen las reglas básicas para navegar y utilizar el sitio web de MOID Tech.'}
            </p>
            {sections.map((section, index) => (
              <section id={`legal-section-${index + 1}`} className="legal-section" key={section.title}>
                <span className="legal-section-number">{String(index + 1).padStart(2, '0')}</span>
                <div>
                  <h2>{section.title.replace(/^\d+\.\s*/, '')}</h2>
                  {section.paragraphs.map((paragraph, paragraphIndex) => (
                    <p key={paragraph}>
                      {isPrivacy && index === 4 && paragraphIndex === 0
                        ? <>
                            Google Analytics utiliza cookies o tecnologías similares para distinguir visitas y medir la actividad del sitio. Puedes limitar o borrar cookies desde la configuración de tu navegador. El tratamiento de datos por Google se rige también por la{' '}
                            <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer">política de privacidad de Google</a>. El tratamiento de datos por Meta se rige también por su{' '}
                            <a href="https://www.facebook.com/privacy/policy/" target="_blank" rel="noreferrer">política de privacidad</a>. Los demás enlaces a sitios de terceros están sujetos a sus propias políticas y prácticas; te recomendamos consultarlas antes de compartir información con ellos.
                          </>
                        : paragraph}
                    </p>
                  ))}
                </div>
              </section>
            ))}
            <div className="legal-note">
              <span aria-hidden="true">↗</span>
              <p>Para cualquier consulta relacionada con este documento, puedes escribirnos a <a href="mailto:hola@moid.tech">hola@moid.tech</a>.</p>
            </div>
          </article>
        </div>
      </main>

      <footer className="legal-footer">
        <Link to="/" className="legal-footer-brand">MOID<span> TECH</span></Link>
        <span>© {new Date().getFullYear()} MOID Tech</span>
        <nav aria-label="Enlaces legales">
          <Link to="/terms-and-conditions">Términos y condiciones</Link>
          <Link to="/privacy-policy">Política de privacidad</Link>
        </nav>
      </footer>
    </div>
  );
}

export const PrivacyPolicy = () => <LegalPage type="privacy" />;
export const TermsAndConditions = () => <LegalPage type="terms" />;
